import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "root"
}
const _hoisted_2 = {
  class: "content",
  relative: ""
}
const _hoisted_3 = { class: "view" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Navbar = _resolveComponent("Navbar")
  const _component_router_view = _resolveComponent("router-view")

  return ($options.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Navbar, { ref: "navbar" }, null, 512 /* NEED_PATCH */),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createBlock(_component_router_view, { key: $data.key }))
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}